import { randomId } from "@/utils/math.utils";

const ALERTS_TYPE = {
  ERROR: "error",
  SUCCES: "success"
};

const ALERT_TIMEOUT = 5000;

export default {
  namespaced: true,
  state: {
    alerts: []
  },
  mutations: {
    pushAlert(state, alert) {
      state.alerts.push(alert);
    },
    removeAlert(state, { id }) {
      state.alerts = state.alerts.filter(alert => alert.id !== id);
    }
  },
  actions: {
    async notifyError({ commit }, { code }) {
      const alertId = randomId();
      commit("pushAlert", { id: alertId, type: ALERTS_TYPE.ERROR, code });

      setTimeout(() => {
        commit("removeAlert", { id: alertId });
      }, ALERT_TIMEOUT);
    }
  },
  getters: {
    alerts: state => {
      return state.alerts;
    }
  }
};
